<div class="alert alert-success" *ngIf="approveAlertSuccess">
  Hoshin approved successfully!
</div>
<div class="alert alert-success" *ngIf="rejectAlertSuccess">
  Hoshin rejected successfully!
</div>
<div class="alert alert-success" *ngIf="saveAlertSuccess">
  Hoshin saved successfully!
</div>
<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>
<div class="budget-control-outer-div comman-padding">
  <div class="col-md-12 col-xs-12 col-sm-12 heading"
    *ngIf="(this.budgetData.budgetStatus=='SUBMITTED')&& (this.adminId ==1 || this.adminId ==4 || isNaacAdmin)">
    <span class="span-create-edit-hoshin">APPROVE HOSHIN</span>
  </div>
  <div class="col-md-12 col-xs-12 col-sm-12 heading">
    <span class="span-create-edit-hoshin">HOSHIN VIEW</span>
    <button class="btn btn-danger hide-button-print print-button col-sm-2 col-md-2" (click)="printPage()">PRINT</button>

  </div>


  <div class="col-md-12 col-xs-12 col-sm-12 div-padding">

    <div class="col-md-6 inlineFlex paddLzero space">
      <span class="col-md-5 paddLzero">Chapter</span>
      <span class="col-md-6 desc-color">{{budgetData.siteName}}-{{budgetData.chapterName}}</span>
    </div>

    <div class="col-md-6 inlineFlex paddLzero space">
      <span class="col-md-5 paddLzero">Fiscal Year</span>
      <span class="col-md-6 desc-color">{{budgetData.fiscalYear}}</span>
    </div>

    <div class="col-md-6 inlineFlex paddLzero space">
      <span class="col-md-5 paddLzero">Affinity Goals</span>
      <span class="col-md-6 desc-color" [innerHtml]="budgetData.affinityGoals">
        <!-- {{budgetData.affinityGoals}} -->
      </span>
    </div>
    <div class="col-md-6 inlineFlex paddLzero space">
      <span class="col-md-5 paddLzero">Chapter Goals</span>
      <span class="col-md-6 desc-color" [innerHtml]="budgetData.chapterGoals">
        <!-- {{budgetData.chapterGoals}} -->
      </span>
    </div>

    <div class="col-md-6 inlineFlex paddLzero space">
      <span class="col-md-5 paddLzero">Budget Status</span>
      <span class="col-md-6 desc-color" [innerHtml]="budgetData.budgetStatus">
        <!-- {{budgetData.chapterGoals}} -->
      </span>
    </div>



  </div>


  <div class="col-md-12  outerdiv">
    <div class="top-space1 " *ngFor="let hoshin of hoshins; let i=index;">
      <div class="div-style">
        <div class="col-md-9 mobile-pading">
          <label class=" budget-control budget-heading budget-name-width">
            <!-- <div data-toggle="collapse" [attr.data-target]="'#budgetId'+ i" class="budget-name-width"> -->
            <span class="reponse-font" >BPG Initiative </span>
          </label>
          <label class="approval respone-hide initiative-style" style="margin-right: 20px;font-weight: bold;">
           
          {{hoshin.bpgInitiative}}
          </label>
          <label class="approval respone-hide" *ngIf="!hoshin.isSuperAdminApproved"  style="margin-right: 20px;"
           >
           <span style="color:black;">Status : </span><span style="font-weight: bold">Pending Approval</span>
          </label>
          <label class="approval respone-hide" *ngIf="hoshin.isSuperAdminApproved"  style="margin-right: 20px;"
          >
          <span style="color:black;">Status : </span><span style="font-weight: bold">Approved</span>
         </label>
          <!-- <label class="approval respone-hide" *ngIf="hoshin.isSuperAdminApproved && hoshin.superAdminApprovedBudget"  style="margin-right: 20px"
          >
          <span style="color:black">Approved Amount : </span><span style="font-weight: bold">${{hoshin.superAdminApprovedBudget}}</span>
         </label> -->
        </div>
        <div class="col-md-3 div-left-style ">

          <label *ngIf="(this.budgetData.budgetStatus == 'SUBMITTED') && (this.adminId == 1 || this.adminId ==4 || isNaacAdmin)"
            class="reponse-height approve-style margin-style mobile-display"> Approve
            <input type="checkbox" name="approveCheck" [(ngModel)]="hoshin.isSuperAdminApproved"
              (change)="toggleCheckbox($event,i)">
            <span class="label-text vertical-style iphone-space"></span>
          </label>

          <div (click)="isCollapsed[i] = !isCollapsed[i]" class="toggle-style iphone-margin hide-button-print">
            <img src="assets/images/arrow-down.png" alt="Angular Logo" *ngIf="!isCollapsed[i]" class="float response-img"
              data-toggle="collapse" [attr.data-target]="'#budgetId'+ i">

            <img src="assets/images/arrow-up.png" alt="Angular Logo" *ngIf="isCollapsed[i]" class="float response-img hide-button-print"
              data-toggle="collapse" [attr.data-target]="'#budgetId'+ i">
          </div>


        </div>
      </div>
      <hr>

      <div id="budgetId{{i}}" class="collapse collapse-div form-font-family"
        [ngClass]="{'print-display': printClicked == true}">


        <div class="col-md-6 inlineFlex paddLzero space">
          <label for="bpgInitiative{{i}}" class="col-md-4 paddLzero">BPG Initiative</label>
          <span class="col-md-7 desc-color">{{hoshin.bpgInitiative}}</span>
        </div>

        <div class="col-md-6 inlineFlex paddLzero space">
          <label for="status{{i}}" class="col-md-4 paddLzero">Status</label>
          <span class="col-md-7 desc-color">{{hoshin.status}}</span>
        </div>

        <div class="col-md-6 inlineFlex paddLzero space">
          <label for="businessDrivers{{i}}" class="col-md-4 paddLzero">Business Drivers</label>
          <span class="col-md-7 desc-color">{{hoshin.businessDrivers}}</span>
        </div>

        <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.proposedBudget">
          <label for="proposedBudget{{i}}" class="col-md-4 paddLzero">Proposed Budget</label>
          <span class="col-md-7 desc-color">{{hoshin.proposedBudget  | currency:'USD'}}</span>
        </div>


        <div class="col-md-6 inlineFlex paddLzero space">
          <label for="actionPlan{{i}}" class="col-md-4 paddLzero">Frequency</label>
          <span class="col-md-7 desc-color">{{hoshin.frequency}}</span>
          <!-- {{hoshin.actionPlan}} -->
        </div>

        <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.frequency == 'One-Time'">
          <label for="estimatedTiming{{i}}" class="col-md-4 paddLzero">Estimated Timing</label>
          <span class="col-md-7 desc-color">{{hoshin.estimatedTiming}}</span>
        </div>

        <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.lead1Name">
          <label for="businessDrivers{{i}}" class="col-md-4 paddLzero">Lead 1</label>
          <span class="col-md-7 desc-color">{{hoshin.lead1Name}}</span>
        </div>

        <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.lead2Name">
          <label for="businessDrivers{{i}}" class="col-md-4 paddLzero">Lead 2</label>
          <span class="col-md-7 desc-color">{{hoshin.lead2Name}}</span>
        </div>


        <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.actionPlan">
          <label for="actionPlan{{i}}" class="col-md-4 paddLzero">Action Plan</label>
          <span class="col-md-7 desc-color" [innerHtml]="hoshin.actionPlan">
            <!-- {{hoshin.actionPlan}} -->
          </span>
        </div>
        <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.kpi">
          <label for="kpi{{i}}" class="col-md-4 paddLzero">KPI</label>
          <span class="col-md-7 desc-color" [innerHtml]="hoshin.kpi">
            <!-- {hoshin.kpi}} -->
          </span>
        </div>


        <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.midYearResults">
          <label for="midYearResults{{i}}" class="col-md-4 paddLzero">Mid Year Results</label>
          <span class="col-md-7 desc-color" [innerHtml]="hoshin.midYearResults">
          </span>
        </div>
        <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.yearEndResults">
          <label for="yearEndResults{{i}}" class="col-md-4 paddLzero">Year End Results</label>
          <span class="col-md-7 desc-color" [innerHtml]="hoshin.yearEndResults">
            <!-- {{hoshin.yearEndResults}} -->
          </span>
        </div>
        <!-- <div class="col-md-6 inlineFlex paddLzero space">
                            <label for="budgetType{{i}}"  class="col-md-4 paddLzero">Budget Type</label>
                            <span class="col-md-7 desc-color">{{hoshin.budgetType}}</span>
                          </div> -->

        <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.challenges">
          <label for="challenges{{i}}" class="col-md-4 paddLzero"> Challenges/Counter Measure</label>
          <span class="col-md-7 desc-color" [innerHtml]="hoshin.challenges">
            {{hoshin.challenges}}
          </span>
        </div>

        <div *ngIf="hoshin.additionalFunding != null" class="col-md-6 inlineFlex paddLzero space">
          <label for="additionalFunding{{i}}" class="col-md-4 paddLzero">Additional Funding</label>
          <span class="col-md-7 desc-color">${{hoshin.additionalFunding}}</span>
        </div>

        <div *ngIf="hoshin.evaluation != null" class="col-md-6 inlineFlex paddLzero space">
          <label for="evaluation{{i}}" class="col-md-4 paddLzero">Evaluation</label>
          <span class="col-md-7 desc-color">{{hoshin.evaluation}}</span>
        </div>

        <div *ngIf="hoshin.additionalFundingSource != null" class="col-md-6 inlineFlex paddLzero space">
          <label for="additionalFundingSource{{i}}" class="col-md-4 paddLzero additional-funding-text-align">Additional
            Funding Source</label>
          <span class="col-md-7 desc-color">{{hoshin.additionalFundingSource}}</span>
        </div>
        <!-- <div class="col-md-6 inlineFlex paddLzero space">
                        <label for="supportingDoc{{i}}"  class="col-md-4 paddLzero">Suporting Doc</label>
                        <span class="col-md-7 desc-color">{{hoshin.supportingDoc}}</span>
                        /div> -->
        <div class="col-md-6 inlineFlex paddLzero space"
          *ngIf="hoshin.isSuperAdminApproved && ((this.budgetData.budgetStatus =='SUBMITTED' && (this.adminId == 1 || this.adminId ==4 || isNaacAdmin)) || this.budgetData.budgetStatus == 'APPROVED')">
          <label for="superAdminApprovedBudget{{i}}" class="col-md-4 paddLzero">Approval Amount <span
              *ngIf="this.budgetData.budgetStatus != 'APPROVED'">($)</span>

            <label *ngIf="this.budgetData.budgetStatus != 'APPROVED'" class="mandatory-asterisk">*</label></label>
          <input *ngIf="this.budgetData.budgetStatus != 'APPROVED'"
            class=" desc-color col-md-7  inputs-padding form-control form-element input-lg" autocomplete="off"
            type="number" id="superAdminApprovedBudget{{i}}" [(ngModel)]="hoshin.superAdminApprovedBudget"
            placeholder="Enter amount" name="superAdminApprovedBudget{{i}}" #superAdminApprovedBudget="ngModel"
            (blur)="findTotalBudgetAmount()"
            onkeypress='return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46 '>
          <span *ngIf="this.budgetData.budgetStatus == 'APPROVED'"
            class="col-md-7 desc-color">{{hoshin.superAdminApprovedBudget  | currency:'USD'}}</span>
        </div>

        <div class="col-md-6 inlineFlex paddLzero space"
          *ngIf="((this.budgetData.budgetStatus =='SUBMITTED' && (this.adminId == 1 || this.adminId ==4 || isNaacAdmin)) || ((this.budgetData.budgetStatus == 'APPROVED') && (hoshin.superAdminApprovalComment)) || ((this.budgetData.budgetStatus == 'REJECTED') && (hoshin.superAdminApprovalComment)))">
          <label for="superAdminApprovalComment{{i}}" class="col-md-4 paddLzero remove-padding">Approval/Reject Comment
            <label *ngIf="this.budgetData.budgetStatus != 'APPROVED' && this.budgetData.budgetStatus != 'REJECTED'"
              class="mandatory-asterisk"> *</label></label>
          <textarea *ngIf="this.budgetData.budgetStatus != 'APPROVED' && this.budgetData.budgetStatus != 'REJECTED'"
            class="desc-color form-control col-md-7 collapse-control textarea-content"
            id="superAdminApprovalComment{{i}}" [(ngModel)]="hoshin.superAdminApprovalComment"
            placeholder="Enter comment" name="superAdminApprovalComment{{i}}" required></textarea>
          <span *ngIf="this.budgetData.budgetStatus == 'APPROVED' || this.budgetData.budgetStatus == 'REJECTED'"
            class="col-md-7 desc-color">{{hoshin.superAdminApprovalComment}}</span>
        </div>

        <div *ngIf="hoshin.claimedAmount != null" class="col-md-6 inlineFlex paddLzero space">
          <label for="claimedAmount{{i}}" class="col-md-4 paddLzero">Claimed Amount</label>
          <span class="col-md-7 desc-color">{{hoshin.claimedAmount  | currency:'USD'}}</span>
        </div>


      </div>


    </div>


    <div class="amount-style">
      <div class="col-md-6 inlineFlex paddLzero space-style paddL">
        <label class="col-md-6 paddLzero font-headding">Requested Amount </label><span
          class="col-md-1 font-headding">:</span>
        <span class="col-md-5 font-headding">{{budget.requestedBudgetAmount  | currency:'USD'}}</span>
      </div>
      <div class="col-md-6 inlineFlex paddLzero space-style">
        <label class="col-md-6 paddLzero font-headding paddM">Approved Amount</label><span
          class="col-md-1 font-headding">:</span>
          <span class="col-md-5 font-headding">{{budget.approvedBudgetAmount  | currency:'USD'}}</span>
        <!-- <span class="col-md-5 paddM font-headding">$<input class="total-budget-input" type="text"
            id="approvedBudgetAmount" autocomplete="off" [(ngModel)]="budget.approvedBudgetAmount"
            name="approvedBudgetAmount" #approvedBudgetAmount="ngModel" readonly></span> -->
      </div>
    </div>

    <div class="top-space text-center">
      <span>
        <p class="alert-invalid" *ngIf="approveComment">*Please enter Approve/Reject comment</p>
        <p class="alert-invalid" *ngIf="approveAmount">*Please enter approve amount</p>
        <button *ngIf="(this.budgetData.budgetStatus == 'SUBMITTED') && (this.adminId == 1 || this.adminId ==4 || isNaacAdmin)" type="button"
          id="saveClick" class="btn btn-danger col-sm-2 col-md-2" data-toggle="modal" data-target="#myModal"
          (click)="saveBtnClick()">SAVE</button>
      </span>
      <span class="preview"></span>
      <span>
        <button *ngIf="(this.budgetData.budgetStatus == 'SUBMITTED') && (this.adminId == 1 || this.adminId ==4 || isNaacAdmin)" type="button"
          id="approveBtnClick" class="btn btn-danger col-sm-2 col-md-2 " [disabled]="(alertTrue==false)"
          (click)="approveBtnClick()">APPROVE</button>
      </span>
      <span class="preview"></span>
      <span>
        <button *ngIf="(this.budgetData.budgetStatus == 'SUBMITTED') && (this.adminId == 1 || this.adminId ==4 || isNaacAdmin)" type="button"
          id="rejectBtnClick" class="btn btn-danger col-sm-2 col-md-2 " [disabled]="(alertTrue==true)"
          (click)="rejectBtnClick()">REJECT</button>
        <span class="preview"></span>
      </span>
      <button type="button" class="btn btn-danger col-sm-2 col-md-2 hide-button-print" (click)="goBack()"
        [disabled]="approveAlertSuccess||rejectAlertSuccess">BACK</button>
      <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="1"></app-confirmation-modal>
    </div>
  </div>
</div>